import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  combinedPositions: null,
}

const getters = {
  futureFlightSchedules(params) {
    // Pull data for 48hours which is 2 days
    return axios.get(
      `/FlightAware/FutureFlightSchedule/${params.tail}?numberOfDaysOfFutureFlights=2`,
    )
  },
  lastUpdatedDate(params) {
    return axios.get(`/FlightAware/GetLastUpdatedDate/${params.tail}`)
  },
}

export default class FullFlightService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
